import { useLoaderData } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { ServiceDto } from '../application/dto/ServiceDto';
import { ServiceCard } from './ServiceCard';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import { staticSeo } from '../../../app/seo/static-seo.content';
import './ServicesPage.css';

export function ServicesPage() {
  const services = useLoaderData() as ServiceDto[];
  useDocumentHead(staticSeo.servicesList);

  return (
    <Container>
      <section className="dma-services-page">
        <h1>خدمات</h1>
        <div className="dma-services-page__grid">
          {services.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </section>
    </Container>
  );
}
